export const AddExtraProps = (
  Component: JSX.Element,
  extraProps: { [propName: string]: any }
) => {
  return <Component.type {...Component.props} {...extraProps} />;
};
